<template>
  <Doughnut :chartData="chartData" :chartOptions="chartOptions" />
</template>

<script setup>
import { toRefs } from 'vue'
import { Doughnut } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

// eslint-disable-next-line
const props = defineProps({
  chartData: {
    type: Object,
    default() {
      return {
        labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
        datasets: [
          {
            backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
            data: [40, 20, 80, 10],
          },
        ],
      }
    },
  },
  chartOptions: {
    type: Object,
    default() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'left',
            onHover: handleHover,
            onLeave: handleLeave,
            onClick(e, legendItem, legend) {
              legend.chart.toggleDataVisibility(legendItem.index)
              legend.chart.update()
            },
            labels: {
              color: '#fff',
              boxWidth: 12,
              boxHeight: 12,
              font: {
                size: 16,
              },
              generateLabels(chart) {
                const data = chart.data
                if (data.labels.length && data.datasets.length) {
                  const {
                    labels: { pointStyle },
                  } = chart.legend.options

                  return data.labels.map((label, i) => {
                    const meta = chart.getDatasetMeta(1)
                    const style = meta.controller.getStyle(i)

                    return {
                      text: label,
                      fillStyle: style.backgroundColor,
                      strokeStyle: style.borderColor,
                      lineWidth: style.borderWidth,
                      pointStyle: pointStyle,
                      hidden: !chart.getDataVisibility(i),
                      index: i,
                      datasetIndex: 1,
                    }
                  })
                }
                return []
              },
            },
          },
          tooltip: {
            callbacks: {
              label(tooltipItem) {
                return (
                  tooltipItem.datasetIndex > 0 &&
                  tooltipItem.label + tooltipItem.formattedValue + '%'
                )
              },
            },
          },
          tooltips: {
            enabled: false,
          },
        },
      }
    },
  },
})
const { chartData, chartOptions } = toRefs(props)
</script>

<script>
function handleHover(evt, item, legend) {
  legend.chart.data.datasets[1].backgroundColor.forEach(
    (color, index, colors) => {
      colors[index] =
        index === item.index || color.length === 9 ? color : color + '4D'
    }
  )
  legend.chart.update()
}
function handleLeave(evt, item, legend) {
  legend.chart.data.datasets[1].backgroundColor.forEach(
    (color, index, colors) => {
      colors[index] = color.length === 9 ? color.slice(0, -2) : color
    }
  )
  legend.chart.update()
}
</script>

<style scoped lang="scss"></style>
